import React, { Fragment, useState } from "react"
import { FaFilter } from "react-icons/fa"
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import {
  Select,
  Button,
  DatePickerWithInput,
  UsersSelectFilter,
  BranchSelectFilter,
  PaymentSelectFilter
} from "components"
import { deliveryTypeLabels } from "constants"
import OrdersHeaderModal from "./OrdersHeaderModal"
import classes from "./index.module.scss"

const OrdersHeader = props => {
  const { filters, setFilters } = props

  const [t] = useTranslation()

  const [openModal, setOpenModal] = useState(false)

  const handleChange = (value, name) => {
    if (filters[name] === value) return

    setFilters(prev => ({ ...prev, [name]: value }))
  }

  const handleChangeDate = (range) => {
    setFilters(prev => ({
      ...prev,
      fromDate: range[0],
      toDate: range[1]
    }))
  }

  const getFiltersCount = () => {
    let filtersCount = 0

    if (!!filters.fromDate) {
      filtersCount++
    }

    if (!!filters.branchId) {
      filtersCount++
    }

    if (!!filters.paymentTypes) {
      filtersCount++
    }

    if (!!filters.selectedAccount) {
      filtersCount++
    }

    if (!!filters.addedByAccount) {
      filtersCount++
    }

    if (!!filters.deliveryType) {
      filtersCount++
    }

    if (!!filters.addedBySystem) {
      filtersCount++
    }

    return filtersCount
  }

  const filtersCount = getFiltersCount()

  const deliveryTypeOptions =
    Object.keys(deliveryTypeLabels).map(deliveryType => ({
      label: deliveryTypeLabels[deliveryType],
      value: deliveryType
    }))

  const addedBySystemOptions = [
    { label: "پرسنل", value: true },
    { label: "سایت", value: false }
  ]

  const addedBySystemSelectValue =
    filters.addedBySystem !== null
      ?
      {
        label: filters.addedBySystem ? "پرسنل" : "سایت",
        value: filters.addedBySystem
      }
      : null

  const deliveryTypeSelectValue =
    deliveryTypeOptions.find(deliveryTypeOption =>
      deliveryTypeOption.value === filters.deliveryType
    )

  return (
    <Fragment>
      <div className={classes["header"]}>
        <Row className={classes["left"]}>
          <Col sm={6} lg={3}>
            <DatePickerWithInput
              isClearable
              className={classes["input-left-1"]}
              type="rangeDatePicker"
              label={t("تاریخ_ایجاد_سفارش")}
              placeholder={t("بازه_زمانی")}
              maxDate={new Date().toISOString()}
              onChange={handleChangeDate}
              range={!!filters.fromDate
                ? [filters.fromDate, filters.toDate]
                : []
              }
            />
          </Col>

          <Col sm={6} lg={3}>
            <UsersSelectFilter
              role="user"
              label={t("مشتریان")}
              placeholder={t("مشتریان_را_جست_و_جو_کنید")}
              className={classes["input-left-1"]}
              value={filters.selectedAccount}
              onChange={(select) => handleChange(select, "selectedAccount")}
            />
          </Col>

          <Col sm={6} lg={3}>
            <UsersSelectFilter
              role="access"
              label={t("پرسنل")}
              placeholder={t("پرسنل_را_جست_و_جو_کنید")}
              value={filters.addedByAccount}
              className={classes["input-left-1"]}
              onChange={(select) => handleChange(select, "addedByAccount")}
            />
          </Col>

          <Col sm={6} lg={3}>
            <PaymentSelectFilter
              isMulti
              isClearable
              className={classes["input-left-1"]}
              onChange={(select) => handleChange(select, "paymentTypes")}
              value={filters.paymentTypes}
            />
          </Col>

          <Col sm={6} lg={3}>
            <Select
              isSearchable={false}
              isClearable
              label={t("طریق_سفارش")}
              placeholder={t("طریق_سفارش_را_انتخاب_کنید")}
              noOptionsMessage={() => null}
              className={classes["input-left-1"]}
              options={addedBySystemOptions}
              value={addedBySystemSelectValue}
              onChange={(select) =>
                handleChange(select?.value !== undefined ? select.value : null, "addedBySystem")
              }
            />
          </Col>

          <Col sm={6} lg={3}>
            <Select
              isClearable
              isSearchable={false}
              label={t("نوع_تحویل")}
              placeholder={t("نوع_تحویل_را_انتخاب_کنید")}
              options={deliveryTypeOptions}
              value={deliveryTypeSelectValue}
              className={classes["input-left-1"]}
              onChange={(select) => handleChange(select?.value, "deliveryType")}
            />
          </Col>

          <Col sm={6} lg={3}>
            <BranchSelectFilter
              className={classes["input-left-1"]}
              onChange={(select) => handleChange(select?.value || "", "branchId")}
              value={filters.branchId}
            />
          </Col>
        </Row>

        <Button
          color="warning"
          className={classes["filter"]}
          onClick={() => setOpenModal(true)}
        >
          <FaFilter className={classes["filter-icon"]} />
          <span className={classes["filter-text"]}>
            {t("فیلتر")}
          </span>

          {
            filtersCount > 0 &&
            <span className={classes["filter-badge"]}>
              {filtersCount}
            </span>
          }
        </Button>
      </div>

      <OrdersHeaderModal
        filters={filters}
        setFilters={setFilters}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </Fragment>
  )
}

export default OrdersHeader